/**
 * The body of the "Add to surgery waitlist" dialog: adds a waitlist entry for the given patient without a
 * progress note. onSuccess is called with the new entry.
 */
app.component("surgeryWaitlistAddForm", {
	templateUrl: "app/src/js/components/surgeryWaitlist/surgeryWaitlistAddForm.html",
	controller: "surgeryWaitlistAddFormController",
	bindings: {
		patient: "<",
		onSuccess: "<",
		onCancel: "<",
	},
});

app.controller("surgeryWaitlistAddFormController", [
	"$scope",
	"SurgeryWaitlistAPI",
	"surgeryWaitlistFormService",
	function ($scope, SurgeryWaitlistAPI, surgeryWaitlistFormService) {
		const ctrl = this;

		$scope.section = {};
		$scope.isSubmitting = false;
		$scope.submitError = null;
		$scope.addAutoTaskWaitlist = undefined;

		$scope.onAutomationTaskChange = function (event) {
			$scope.addAutoTaskWaitlist = event.isAutomationTaskEnabled;
		};

		$scope.isButtonDisabled = function () {
			return $scope.isSubmitting
				|| !(ctrl.patient && ctrl.patient.id)
				|| !$scope.section.clinician_user_id
				|| !$scope.section.preferred_timeframe_type
				|| !surgeryWaitlistFormService.hasRequiredTimeframe($scope.section)
				|| !surgeryWaitlistFormService.hasPrimaryProcedure($scope.section);
		};

		// The field names the waitlist API takes, which differ slightly from the progress note's section.
		function toRequest(section) {
			const body = surgeryWaitlistFormService.withTimeframeForRequest(section);
			return {
				clinician_user_id: body.clinician_user_id,
				primary_procedure_od: body.primary_procedure_od,
				primary_procedure_os: body.primary_procedure_os,
				secondary_procedure_list: body.secondary_procedure_list,
				comments: body.wait_list_comments,
				preferred_timeframe_type: body.preferred_timeframe_type,
				timeframe_number_of_weeks: body.timeframe_number_of_weeks,
				timeframe_before_date_UTC: body.timeframe_before_date_UTC,
				timeframe_after_date_UTC: body.timeframe_after_date_UTC,
				timezone: body.timezone,
			};
		}

		$scope.submit = function () {
			if ($scope.isButtonDisabled()) {
				return;
			}

			$scope.isSubmitting = true;
			$scope.submitError = null;
			SurgeryWaitlistAPI.createSurgeryWaitlist(ctrl.patient.id, toRequest($scope.section), $scope.addAutoTaskWaitlist).then(function (resp) {
				$scope.$emit("waitlist:query");
				ctrl.onSuccess(resp.data);
			}, function (err) {
				// The server's reason when it gives one (a permission refusal says what is missing)
				$scope.submitError = (err && err.data && err.data.message) || "The entry could not be added. Please try again.";
			}).then(function () {
				$scope.isSubmitting = false;
			});
		};
	},
]);
